import { Injectable } from '@angular/core';

const AUTH_TOKEN_KEY = 'authToken';
const REFRESH_TOKEN_KEY = 'refreshToken';
const THEME_KEY = 'user_theme';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private isLocalStorageAvailable(): boolean {
    return typeof localStorage !== 'undefined';
  }

  // Métodos síncronos para strings
  getItem(key: string): string | null {
    if (this.isLocalStorageAvailable()) {
      return localStorage.getItem(key);
    }
    return null;
  }

  setItem(key: string, value: string): void {
    if (this.isLocalStorageAvailable()) {
      localStorage.setItem(key, value);
    }
  }

  // Métodos síncronos para objetos
  getObject<T>(key: string): T | null {
    const item = this.getItem(key);
    return item ? (JSON.parse(item) as T) : null;
  }

  setObject(key: string, value: any): void {
    this.setItem(key, JSON.stringify(value));
  }

  removeItem(key: string): void {
    if (this.isLocalStorageAvailable()) {
      localStorage.removeItem(key);
    }
  }

  clearTokens(): void {
    this.removeItem(AUTH_TOKEN_KEY);
    this.removeItem(REFRESH_TOKEN_KEY);
  }

  // Métodos assíncronos para strings
  async getItemAsync(key: string): Promise<string | null> {
    return Promise.resolve(this.getItem(key));
  }

  async setItemAsync(key: string, value: string): Promise<void> {
    this.setItem(key, value);
    return Promise.resolve();
  }

  // Métodos assíncronos para objetos
  async getObjectAsync<T>(key: string): Promise<T | null> {
    return Promise.resolve(this.getObject<T>(key));
  }

  async setObjectAsync(key: string, value: any): Promise<void> {
    this.setObject(key, value);
    return Promise.resolve();
  }

  async removeItemAsync(key: string): Promise<void> {
    this.removeItem(key);
    return Promise.resolve();
  }

  async clearTokensAsync(): Promise<void> {
    this.clearTokens();
    return Promise.resolve();
  }

  // Métodos para manipular o tema
  setTheme(theme: string): void {
    if (this.isLocalStorageAvailable()) {
      localStorage.setItem(THEME_KEY, theme);
    }
  }

  getTheme(): string | null {
    if (this.isLocalStorageAvailable()) {
      return localStorage.getItem(THEME_KEY);
    }
    return null;
  }

  removeTheme(): void {
    if (this.isLocalStorageAvailable()) {
      localStorage.removeItem(THEME_KEY);
    }
  }
}
